import { API, getToken, api } from "@/lib/api";

export const openAssist = (text = "") => window.dispatchEvent(new CustomEvent("cx-assist-open", { detail: { text } }));

export async function streamChat({ message, sessionId, page, onSession, onDelta, onError }) {
  const res = await fetch(`${API}/assistant/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}`, "X-Lang": document.documentElement.lang || "fr" },
    body: JSON.stringify({ message, session_id: sessionId, page }),
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(typeof j.detail === "string" ? j.detail : "Erreur");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const chunks = buf.split("\n\n");
    buf = chunks.pop();
    for (const c of chunks) {
      if (!c.startsWith("data: ")) continue;
      let ev;
      try { ev = JSON.parse(c.slice(6)); } catch { continue; }
      if (ev.type === "session") onSession(ev.id);
      else if (ev.type === "delta") onDelta(ev.text);
      else if (ev.type === "error") onError(ev.text);
    }
  }
}

export const listSessions = () => api.get("/assistant/sessions").then((r) => r.data);
export const getSession = (id) => api.get(`/assistant/sessions/${id}`).then((r) => r.data);
export const deleteSession = (id) => api.delete(`/assistant/sessions/${id}`);
export const escalate = (id, note) => api.post("/assistant/escalate", { session_id: id, note }).then((r) => r.data);
